import packageData from './package.json';

export default {
    VERSION: packageData.version,
    //API: 'https://portalsubpre.pavasal.com', // test/pre/stage
    API: 'https://portalsub.pavasal.com', // prod
};



// WEBPACK FOOTER //
// ./src/Config.js